"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.logStamp = exports.humanizeFromNow = exports.formatTimezone = exports.mostRecent = exports.titleFromTimeRange = exports.titleFromDateRange = void 0;
const moment_timezone_1 = __importDefault(require("moment-timezone"));
function titleFromDateRange(from, to) {
    if (!from || !to)
        return '';
    const mFrom = (0, moment_timezone_1.default)(from);
    const mTo = (0, moment_timezone_1.default)(to);
    return Math.abs(mFrom.diff(mTo, 'days')) < 1
        ? mFrom.format('Do MMM')
        : mFrom.format(mFrom.isSame(mTo, 'month') ? 'Do' : 'Do MMM') + mTo.format(' - Do MMM');
}
exports.titleFromDateRange = titleFromDateRange;
function titleFromTimeRange(from, to) {
    if (!from || !to)
        return '';
    const mFrom = (0, moment_timezone_1.default)(from);
    const mTo = (0, moment_timezone_1.default)(to);
    return mFrom.format('HH:mm') + mTo.format(' - HH:mm');
}
exports.titleFromTimeRange = titleFromTimeRange;
function mostRecent(dates) {
    return moment_timezone_1.default.max(dates.filter(d => !!d).map(d => (0, moment_timezone_1.default)(d))).toDate();
}
exports.mostRecent = mostRecent;
function formatTimezone(tzName) {
    return tzName.split('/').join(' > ').split('_').join(' ');
}
exports.formatTimezone = formatTimezone;
function humanizeFromNow(date) {
    if (!date)
        return '';
    return moment_timezone_1.default.duration((0, moment_timezone_1.default)(date).diff((0, moment_timezone_1.default)())).humanize(true);
}
exports.humanizeFromNow = humanizeFromNow;
function logStamp(date, prefix) {
    if (!date)
        return undefined;
    const timeBit = humanizeFromNow(date);
    return [prefix, timeBit].filter(x => !!x).join(' ');
}
exports.logStamp = logStamp;
